import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Shield } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";
import { SettingsFormSkeleton } from "./settings-form-skeleton";

export function UserVerificationSkeleton() {
  return (
    <ListLayout
      description={
        <>
          Verifying user identities keeps your users safe from phishing attacks.
          Learn more in our{" "}
          <a
            className="font-medium text-link hover:underline"
            href="https://docs.arcade.dev/home/auth/secure-auth-production"
            rel="noopener noreferrer"
            target="_blank"
          >
            documentation
          </a>
          .
        </>
      }
      title="User Verification"
    >
      <div className="max-w-5xl">
        <Card className="gap-2 border-border/50 shadow-sm">
          <CardHeader className="pb-6">
            <div className="flex items-start gap-3">
              <Shield className="mt-1 h-6 w-6 text-brand-text" />
              <div>
                <CardTitle>Verification Method</CardTitle>
                <CardDescription className="mt-2 leading-relaxed">
                  Choose how to verify that the person authorizing a tool is the
                  same person who started the process.
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-0">
            <SettingsFormSkeleton />
          </CardContent>
        </Card>
      </div>
    </ListLayout>
  );
}
